import { z } from 'zod';

export const registrationStepSevenSchema = z.object({
    regions: z.array(z.object({ label: z.string(), value: z.number() })).nullable(),
});

export type RegistrationStepSevenSchema = z.infer<typeof registrationStepSevenSchema>;
